<template>
  <div class="gray-bcg">
    <myheader class="relative" />
    <img
      src="../../assets/image/blueShape.png"
      alt="blueShape"
      class="blueShape"
      width="50%"
    />
    <img
      src="../../assets/image/greenShape.png"
      alt="greenShape"
      width="30%"
      class="greenShape"
    />
    <!-- /////////////////هدر پنل//////////////////// -->
    <v-toolbar class="green-bcg">
      <v-toolbar-items class="hidden-sm-and-down" align="center">
        <div class="col-4 mt-n3">
          <router-link to="/panelOrderHistory" class="link">
            <div
              class="p-2 mx-3 mt-3 b1 text-light pointer"
              :class="{ currentComponent: orderHistory }"
            >
              {{ $t("panelUser.history") }}
            </div></router-link
          >
        </div>
        <div class="col-4 mt-n3">
          <router-link to="/panelInfo" class="link">
            <div
              class="p-2 mx-3 mt-3 b1 text-light pointer"
              :class="{ currentComponent: info }"
            >
              {{ $t("panelUser.yourInfo") }}
            </div></router-link
          >
        </div>
        <div class="col-4 mt-n3">
          <router-link to="/panelRecivers" class="link">
            <div
              class="p-2 mx-3 mt-3 b1 text-light pointer"
              :class="{ currentComponent: recivers }"
            >
              {{ $t("panelUser.recivers") }}
            </div></router-link
          >
        </div>

        <div class="col-3 mt-n3">
          <router-link to="/panelComment" class="link">
            <div
              class="p-2 mx-3 mt-3 b1 text-light pointer"
              :class="{ currentComponent: comment }"
            >
              {{ $t("panelUser.comment") }}
            </div></router-link
          >
          <div
            class="row d-flex justify-content-center h1 blue-text mt-n9"
          ></div>
        </div>
      </v-toolbar-items>
      <v-toolbar-items class="d-lg-none" @click.stop="drawer = !drawer">
        <!-- @click="giveHight(), changeHight()" -->
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <router-link to="/panelNewOrder" class="link">
        <span
          class="rounded-pill bcg-light blue-color pointer blue-border py-2 px-3 blue-text b1 bg-light ml-7"
          >{{ $t("order") }} +
        </span></router-link
      >
    </v-toolbar>
    <cardDetails class="relative hidden-sm-and-down" v-if="large" />
    <!--//////////////////////////// mobile menue//////////////////////// -->
    <template>
      <v-sheet class="overflow-hidden d-lg-none transition">
        <!-- :height="SmenueH" -->
        <v-navigation-drawer
          v-model="drawer"
          absolute
          temporary
          width="50%"
          height="100%"
        >
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <router-link to="/panelInfo" class="link">
                  <v-list-item-title class="b1 pointer">{{
                    $t("panelUser.yourInfo")
                  }}</v-list-item-title></router-link
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <router-link to="/panelRecivers" class="link">
                  <v-list-item-title class="b1 pointer">{{
                    $t("panelUser.recivers")
                  }}</v-list-item-title></router-link
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <router-link to="/panelOrderHistory" class="link">
                  <v-list-item-title class="b1 pointer">{{
                    $t("panelUser.history")
                  }}</v-list-item-title></router-link
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <router-link to="/panelComment" class="link"
                  ><v-list-item-title class="b1 pointer">{{
                    $t("panelUser.comment")
                  }}</v-list-item-title></router-link
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
        <cardDetails class="relative" v-if="small" />
      </v-sheet>
    </template>

    <myfooter class="relative" />
  </div>
</template>
<script>
import myheader from "../../components/Share/Header.vue";
import myfooter from "../../components/Share/Footer.vue";
import cardDetails from "../../components/panel/CardDetails.vue";

export default {
  data() {
    return {
      small: false,
      large: false,
      drawer: false,
      info: false,
      recivers: false,
      orderHistory: false,
      comment: false,
    };
  },
  components: {
    myheader,
    myfooter,
    cardDetails,
  },
  mounted() {
    if (window.innerWidth >= 992) {
      this.large = true;
      this.small = false;
    } else {
      if (window.innerWidth >= 768) {
        this.small = true;
        this.large = false;
      } else {
        this.small = true;
        this.large = false;
      }
    }
  },
};
</script>
<style scoped>
.greenShape {
  position: absolute;
  top: 20%;
  right: 90%;
}
.blueShape {
  position: absolute;
  top: 20%;
  right: -40%;
}
.pnel-btn {
  background-color: #e76f51 !important;
}
.transition {
  transition: 1s;
}
.currentRout {
  color: #3c56c8 !important;
}
.currentComponent {
  text-decoration: underline;
}
</style>
